import { TYPES } from '../const'
import Shape from './Shape'

export default class Img extends Shape {
	protected readonly type = TYPES.IMG
	protected imgNode: HTMLImageElement
	protected texture: WebGLTexture

	constructor(params) {
		super(params)
		this.sizing = params.sizing || 'cover'
		this.imgNode = params.node
	}

	init(gl, program) {
		super.init(gl, program)
		this.texture = this.getTexture(gl)
	}

	getTexture(gl) {
		const tex = gl.createTexture()
		gl.bindTexture(gl.TEXTURE_2D, tex)
		gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]))

		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)

		return tex
	}

	async loadImgNode(node) {
		if (node.complete) return Promise.resolve()
		return new Promise((resolve, reject) => {
			node.addEventListener('error', reject)
			node.addEventListener('load', resolve)
		})
	}

	async preload(gl?) {
		await this.loadImgNode(this.imgNode)
		this.baseAspect = this.imgNode.naturalWidth / this.imgNode.naturalHeight

		gl.bindTexture(gl.TEXTURE_2D, this.texture)
		gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.imgNode)
	}

	draw(gl) {
		if (!this.visible) return
		gl.useProgram(this.program)
		gl.activeTexture(gl.TEXTURE0)
		gl.bindTexture(gl.TEXTURE_2D, this.texture)
		super.setAttributesAndUniforms(gl)
		gl.drawArrays(gl.TRIANGLES, 0, this.len)
	}
}
